import { ProgressDialog } from '@/components/common/ProgressDialog'
import { importDialogCounts } from './continueBatch'

export function ImportRunDialog({
  progress,
  message,
  pagesDone,
  pagesTotal,
  onCancel,
  cancelling = false,
}: {
  progress: number
  message: string
  pagesDone: number
  pagesTotal: number
  onCancel?: () => void
  cancelling?: boolean
}) {
  const counts = importDialogCounts({ progress, message, pagesDone, pagesTotal })
  return (
    <ProgressDialog
      title="Stundenpläne werden importiert"
      current={counts.current}
      total={counts.total}
      status={cancelling ? 'Wird abgebrochen…' : counts.status}
      hint={cancelling ? 'Der laufende Abschnitt wird noch beendet.' : onCancel ? 'Abbrechen stoppt den Import.' : 'Bitte warten. Das Fenster nicht schliessen.'}
      onCancel={cancelling ? undefined : onCancel}
    />
  )
}
